import { Pipe, PipeTransform } from '@angular/core';
import { UserStubWithState } from '../../../core-data-model';
@Pipe({
    name: 'emailAutocompleteDisplay',
    standalone: false
})
export class EmailAutocompleteDisplayPipe implements PipeTransform {
    transform(entity: UserStubWithState): string {
        return entity.getFullDisplayName();
    }
}
